"use strict";
// Copyright © Veeam Software Group GmbH
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.textWithLinkTableCellRenderer = void 0;
const react_1 = __importDefault(require("react"));
const components_1 = require("@veeam/components");
const constants_1 = require("../../../constants");
const types_1 = require("../types");
function textWithLinkTableCellRenderer(linkTexts) {
    return (columnProps, rowData, rowHeight) => {
        const texts = (rowData[columnProps.field] || '').split(/\s/);
        const content = texts.map((text, idx) => {
            const hasSpace = idx !== texts.length - 1;
            const space = hasSpace ? ' ' : '';
            if (text.match(new RegExp(constants_1.REG_EXP_LIST.url))) {
                const url = new URL(text);
                let linkText = text;
                if (url.pathname.match(new RegExp('kb'))) {
                    linkText = linkTexts.kb;
                }
                if (url.hostname.match(new RegExp('redirect'))) {
                    linkText = linkTexts.userGuide;
                }
                return (react_1.default.createElement(react_1.default.Fragment, { key: idx },
                    react_1.default.createElement(components_1.Link, { href: text, target: components_1.LINK_TARGET.blank, style: { fontSize: 'inherit' } }, linkText),
                    space));
            }
            else {
                return text + space;
            }
        });
        return (react_1.default.createElement(components_1.Text, { truncate: rowHeight !== types_1.TABLE_ROW_HEIGHT.auto, size: components_1.TEXT_SIZE.m, view: components_1.TEXT_VIEW.primary }, content));
    };
}
exports.textWithLinkTableCellRenderer = textWithLinkTableCellRenderer;
//# sourceMappingURL=textWithLinkTableCellRenderer.js.map